import React, { useRef } from "react";
import { string } from "prop-types";
import { SearchBox } from "@quintype/components";

import SearchIcon from "../../atoms/icons/search-icon";

import "./search-input.m.css";
import { staticTexts } from "../../utils/Translate";

const SearchFormButtonClick = () => {
  if (document.getElementById("searchForm").value === "") {
    window.location = "/search";
  }
};

const DrawForm = ({ children }) => [
  <label htmlFor="searchForm" key="1">
    {children}
  </label>,
  <button type="submit" styleName="search" key="2" onClick={SearchFormButtonClick}>
    <SearchIcon color="#0099ff" width={28} height={28} />
  </button>,
];

const SearchInput = ({ className, defaultValue = "", lang }) => {
  const textInput = useRef();
  const searchForm = useRef();

  return (
    <div styleName="container" className={className}>
      <SearchBox
        inputId="searchForm"
        inputClassName="search__form-input"
        template={DrawForm}
        inputRef={textInput}
        formRef={searchForm}
        placeholder={staticTexts(lang).searchBoxText}
        initValue={defaultValue}
      />
    </div>
  );
};

SearchInput.defaultProps = {
  className: "",
};

SearchInput.propTypes = {
  defaultValue: string,
  className: string,
  lang: string,
};

export default SearchInput;
